import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '@cimpress-technology/react-platform-header/lib/Header';
import auth from '../auth';
import { getAccount, getArea } from '../api/get-content-area';

export const ContentHeader = (props) => {
  let { accountId, areaId } = useParams();
  const isTenantSpecified = () => accountId && areaId;

  const templatesTranslationLink = (
    <Link to={`/Accounts/${accountId}/ContentArea/${areaId}/TemplatesTranslation/Select`}>
      Batch Template Translation
    </Link>
  );
  const importS3Link = <Link to={`/Accounts/${accountId}/ContentArea/${areaId}/Batches`}>Import S3</Link>;

  const generateAppLinks = () => (isTenantSpecified() ? [importS3Link, templatesTranslationLink] : []);

  const areaName = isTenantSpecified() ? getArea(accountId, areaId).name : null;
  const accountName = getAccount(accountId).name;

  return (
    <>
      <Header
        accessToken={auth.getAccessToken()}
        appTitle={
          <>
            <Link to="/">{accountName}</Link>
            {areaName && <span> / {areaName} </span>}
          </>
        }
        appLinks={generateAppLinks()}
        profile={auth.getProfile()}
        onLogInClicked={() => auth.login()}
        onLogOutClicked={() => auth.logout('/')}
        isLoggedIn={auth.isLoggedIn}
      />
      {props.children}
    </>
  );
};
